import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { PARTNER_UPDATE_STEP1 } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

export const api_update_partner_step1 = (data) => {

    return (dispatch, getState) => {

        Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            return axios.put(`${Config.API_BASE_URL}/partnerwhatif/${data.pageStep}/${data.partnerWhatIfId}`, data, config)
                .then(response => {

                    dispatch({
                        type: PARTNER_UPDATE_STEP1,
                        payload: response.data
                    })
                })
                .catch(error => {

                    dispatch({
                        type: PARTNER_UPDATE_STEP1,
                        payload: {
                            errors: error.response.data
                        }
                    })

                });
        }).catch(error => {
            dispatch({ type: EXPIRED });
        });
    };
}

export default api_update_partner_step1;
